export const AUTH_PATHS = {
  SIGN_IN: "/signin",
  SIGN_UP: "/signup",
} as const

export function isSignInPathname(pathname: string): boolean {
  return (
    pathname === AUTH_PATHS.SIGN_IN ||
    pathname.startsWith(`${AUTH_PATHS.SIGN_IN}/`)
  )
}
